<template>
  <div class="pl-100">
    <!-- Integration is not yet done or successful -->
    <template v-if="!googleCalendarHasError">
      <button-link
        class="is-danger mb-100 ml-auto"
        v-if="googleCalendarIsIntegrated"
        @click="disconnectGoogleCalendarIntegration"
        :loading="isDisconnecting"
        :disabled="isDisconnecting"
      >
        Disconnect Calendar
      </button-link>

      <!-- Setup -->
      <div v-if="!googleCalendarIntegration">
        <button-outlined
          :loading="isSaving"
          :disabled="isSaving"
          @click="createGoogleCalendarIntegration"
        >
          Integrate with Google Calendar
        </button-outlined>
      </div>

      <!-- After Setup -->
      <template v-else>
        <div v-if="needsToAuthIntegration">
          <div v-if="googleCalendarOAuthUrl">
            <a :href="googleCalendarOAuthUrl">
              <button-outlined
                :loading="isSaving"
                :disabled="isSaving"
              >
                Authorize Forefront to Access Google Calendar
              </button-outlined>
            </a>
          </div>

          <div v-else class="hint-text">Please wait while we are setting up Google Calendar authorization...</div>
        </div>

        <!-- Choose Calendar -->
        <template v-if="needsToSetCalender">
          <form-field-select
            label="Calendar"
            v-model="setGoogleCalendarForm.calendar"
            :validation-errors="setGoogleCalendarValidationErrors.calendar"
          >
            <option :value="null" disabled>Select Calendar</option>
            <option
              v-for="calendar in calenderList"
              :key="calendar.id"
              :value="calendar"
            >
              {{ calendar.label }}
            </option>
          </form-field-select>

          <button-default
            class="ml-auto"
            :loading="isSaving"
            :disabled="isSaving || (setGoogleCalendarForm.calendar === null)"
            @click="setGoogleCalendar"
          >
            Sync Calendar
          </button-default>
        </template>

        <!-- Calendar Name -->
        <form-field-input
          v-if="googleCalendarIntegration.data"
          label="Synced Calendar"
          v-model="googleCalendarIntegration.data.calendar_label"
          disabled
        ></form-field-input>
      </template>
    </template>
    <!-- Integration Failed -->
    <template v-else>
      <button-outlined
        class="is-danger"
        :loading="isSaving"
        :disabled="isSaving"
        @click="deleteGoogleCalendarIntegration"
      >
        Reset Integration
      </button-outlined>
    </template>
  </div>
</template>

<script>
export default {
  name: "GoogleCalendarIntegration",
  data() {
    return {
      isSaving: false,
      isDisconnecting: false,
      createGoogleCalendarIntegrationForm: {
        market_id: this.$store.getters.market.id,
      },
      setGoogleCalendarForm: {
        calendar: null,
      },
      createGoogleCalendarIntegrationValidationErrors: {},
      setGoogleCalendarValidationErrors: {},
      googleCalendarOAuthUrl: null,
      calenderList: null,
    }
  },
  computed: {
    googleCalendarIntegration() {
      return this.$store.getters.googleCalendarIntegration;
    },
    googleCalendarHasError() {
      return this.$store.getters.googleCalendarIntegrationError;
    },
    googleCalendarIsIntegrated() {
      return this.$store.getters.googleCalendarIsIntegrated;
    },
    needsToAuthIntegration() {
      if (!this.googleCalendarIntegration) {
        return false;
      }

      return !this.googleCalendarIntegration.token;
    },
    needsToSetCalender() {
      if (!this.googleCalendarIntegration || this.needsToAuthIntegration) {
        return false;
      }

      return !this.googleCalendarIntegration.data;
    }
  },
  mounted() {
    if (this.needsToAuthIntegration) {
      this.$api.googleIntegrations.getOauthUrl(this.googleCalendarIntegration.id).then((response) => {
        this.googleCalendarOAuthUrl = response.data.url;
      });
    }
    if (this.needsToSetCalender) {
      this.$api.calendarIntegrations.getCalendarList(this.googleCalendarIntegration.id).then((response) => {
        this.calenderList = response.data;
      });
    }
  },
  methods: {
    createGoogleCalendarIntegration() {
      this.isSaving = true;

      this.$api.googleIntegrations.createGoogleCalendarIntegration(this.createGoogleCalendarIntegrationForm).then((response) => {
        this.createGoogleCalendarIntegrationValidationErrors = {};
        this.$api.googleIntegrations.getOauthUrl(response.data.id).then((response) => {
          window.location.href = response.data.url;
        });
      }).finally(() => { this.isSaving = false });
    },
    setGoogleCalendar() {
      this.isSaving = true;

      this.$api.calendarIntegrations.setCalender(this.googleCalendarIntegration.id, this.setGoogleCalendarForm.calendar.id, this.setGoogleCalendarForm.calendar.label).then(() => {
        this.setGoogleCalendarValidationErrors = {};
      }).finally(() => { this.isSaving = false });
    },
    deleteGoogleCalendarIntegration() {
      this.isDisconnecting = true;
      this.$api.integrations.deleteIntegration(this.googleCalendarIntegration.id)
        .finally(() => { this.isDisconnecting = false });
    },
    disconnectGoogleCalendarIntegration() {
      this.$utils.confirm(
        "Are you sure you want to <strong>disconnect</strong> Google Calendar?",
        'Disconnect Calendar Integration'
      )
        .then(() => { this.deleteGoogleCalendarIntegration() });
    }
  }
}
</script>
